export default {
    methods: {
        formatNumber: function (value) {
            return (Math.round(value * 100) / 100).toLocaleString('es-ES');
        }
    }
}